<template>
  <div>

     <div v-for="item in data" :key="item.folderId">
      <el-submenu :index="item.folderId" v-if="item.children != null && item.children.length != 0"  >
        <template slot="title">
          <el-tooltip :content="item.folderName" placement="right" :open-delay="500" :enterable="false">
            <span class="menu-item-content" @click="handleNodeClick(item)">
              <i :class="item.icon || 'el-icon-folder'"></i>
              <span class="menu-item-text">{{ item.folderName }}</span>
            </span>
          </el-tooltip>
        </template>
        <files_menu :data="item.children" @node-click="handleNodeClick"></files_menu>
      </el-submenu>
      <el-menu-item v-else :index="item.folderId" @click="handleNodeClick(item)">
        <el-tooltip :content="item.folderName" placement="right" :open-delay="500" :enterable="false">
          <span class="menu-item-content">
            <i :class="item.icon || 'el-icon-folder'"></i>
            <span class="menu-item-text" slot="title">{{ item.folderName }}</span>
          </span>
        </el-tooltip>
      </el-menu-item>
    </div>
  </div>
</template>

<script>
export default {
  name: "files_menu",
  components: {
    'files_menu': () => import('@/components/menu/files_menu.vue')
  },
  props: {
    data: Array,
  },
  methods: {
    handleNodeClick(data) {
      this.$emit('node-click', data);
    }
  }
}
</script>

<style scoped lang="scss">
/*隐藏文字*/
.el-menu--collapse .el-submenu__title span {
  display: none;
}

/*隐藏 > */
.el-menu--collapse .el-submenu__title .el-submenu__icon-arrow {
  display: none;
}

.menu-item-content {
  display: inline-flex;
  align-items: center;
  width: 100%;
  overflow: hidden;

  i {
    flex-shrink: 0;
    margin-right: 6px;
  }

  .menu-item-text {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex: 1;
    min-width: 0;
  }
}
</style>
